import React from 'react';
import { Link } from 'react-router-dom';
import './Public.css';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="pub-footer" id="contact">
      <div className="pub-container">
        <div className="pub-footer-grid">
          <div className="pub-footer-brand">
            <div className="pub-logo">
              <span className="pub-logo-mark">E</span>
              <span className="pub-logo-text" style={{ color: '#fff' }}>Event<span style={{ color: '#A07BFF' }}>Hub</span></span>
            </div>
            <p>Discover, register, and attend the events that matter to you — workshops, conferences, and everything in between, all in one place.</p>
          </div>
          <div className="pub-footer-col">
            <h4>Explore</h4>
            <Link to="/">All Events</Link>
            <a href="/#features">Why EventHub</a>
            <a href="/#contact">Contact</a>
          </div>
          <div className="pub-footer-col">
            <h4>Support</h4>
            <a href="/#">Help Center</a>
            <a href="/#">FAQ</a>
            <a href="/#">Privacy</a>
          </div>
          <div className="pub-footer-col">
            <h4>Organizers</h4>
            <Link to="/admin/login">Admin Login</Link>
            <a href="/#">Host an Event</a>
          </div>
        </div>
        <div className="pub-footer-bottom">
          <p>© {year} EventHub. All rights reserved.</p>
          <div className="pub-footer-social">
            <a href="/#" aria-label="X">𝕏</a>
            <a href="/#" aria-label="LinkedIn">in</a>
            <a href="/#" aria-label="Instagram">◎</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
